import * as angular from "angular";
import {ToggleController} from "./toggle.controller";
const templateUrl = require("./toggle.html");

export const toggle: angular.IComponentOptions = {
    templateUrl: templateUrl,
    controller: ToggleController,
    controllerAs: "vm",
    bindings: {
        name: "@",
        onChange: "&",
        large: "@",
        value: "<",
        debounce: "@"
    }
};


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/common/toggle/toggle.ts
 **/